var styles = {"checkboxGroupWrapper":"VDS__MON__checkbox-group-module__lAnMM"};

export { styles as default };
